/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonEventPartyDay,
    JsonEventPartyDayFromJSON,
    JsonEventPartyDayFromJSONTyped,
    JsonEventPartyDayToJSON,
} from './JsonEventPartyDay';

/**
 * 
 * @export
 * @interface ApiResultOfJsonEventPartyDay
 */
export interface ApiResultOfJsonEventPartyDay {
    /**
     * 
     * @type {JsonEventPartyDay}
     * @memberof ApiResultOfJsonEventPartyDay
     */
    data?: JsonEventPartyDay;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventPartyDay
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonEventPartyDay
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventPartyDay
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventPartyDay
     */
    result?: ApiResultOfJsonEventPartyDayResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonEventPartyDayResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonEventPartyDayFromJSON(json: any): ApiResultOfJsonEventPartyDay {
    return ApiResultOfJsonEventPartyDayFromJSONTyped(json, false);
}

export function ApiResultOfJsonEventPartyDayFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonEventPartyDay {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonEventPartyDayFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonEventPartyDayToJSON(value?: ApiResultOfJsonEventPartyDay | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonEventPartyDayToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

